exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".store-scan-required-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5);z-index:29}.store-scan-required-overlay.notifications-open{z-index:500}.store-scan-required-content{position:absolute;top:3.5em;width:100%;bottom:0;background:#fff;padding:24px;box-sizing:border-box}", ""]);

// exports
